const woodyDoorHeightOptions = ['25', '42'];

export default woodyDoorHeightOptions;
